<template>
  <footer class="site-footer">
    <div class="container">
      <div class="footer-grid">
        <div>
          <router-link to="/" class="brand">
            <img src="images/logo-white.png" alt="">
            <span>Ten Factor Growth</span>
          </router-link>
          <p style="margin-top:16px;max-width:34ch">Part-time executive advisory for technology companies.</p>
        </div>
        <div class="footer-links">
          <div>
            <h4>Explore</h4>
            <ul>
              <li><router-link to="/about">About</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/projects">Projects</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div>
            <h4>Get in touch</h4>
            <ul>
              <li><a href="mailto:brian@tenfactorgrowth.com">brian@tenfactorgrowth.com</a></li>
              <li>Boston, Massachusetts</li>
              <li><a href="https://www.linkedin.com/in/brianeberman/" target="_blank" rel="noopener">LinkedIn</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="fine">
        <span>&copy; {{ year }} Ten Factor Growth</span>
        <router-link to="/privacy">Terms and privacy</router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
    name: 'SiteFooter',
    computed: {
        year() { return new Date().getFullYear() }
    }
}
</script>
